import React from 'react';
import { StepEditorContentFilePreview } from 'src/editor/step-editor/content/file/preview';
import { WizardContentListCardWrapper, WizardContentListCardWrapperProps } from './wrapper';
import { functionNoop } from 'src/utils/function/noop';
import { useFilesUploadStore } from 'src/common/store/files-upload.store';
import { REMOVE_STACK_DELAY_IN_MS } from 'src/dashboard/library/content';
import delay from 'lodash/delay';

interface Props extends WizardContentListCardWrapperProps {
  file: File;
  meta?: string;
}

export const WizardContentListCardFile = ({ file, meta, onDeleteClick }: Props) => {
  const ongoingUploadStack = useFilesUploadStore((state) => state.getOngoingUploadStack(file.name));

  const cancelOngoingUpload = () => {
    ongoingUploadStack?.abortCall();
  };

  return (
    <WizardContentListCardWrapper
      isDeleteDisabled={ongoingUploadStack && !ongoingUploadStack.cancellable}
      onDeleteClick={() => {
        delay(cancelOngoingUpload, REMOVE_STACK_DELAY_IN_MS);
        onDeleteClick();
      }}
    >
      <StepEditorContentFilePreview
        file={file}
        fileMeta={meta}
        titleClassName='text-bedrock-p'
        onUploadCompleted={functionNoop}
      />
    </WizardContentListCardWrapper>
  );
};
